export default __webpack_public_path__ + "static/media/phone-icon.0ebecde2.svg";